import { Flex, Icon, IconButton, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaTimes } from "react-icons/fa";
import { ContractFieldOption, getDataFieldTranslationKey } from "./DataFieldSelector";
import { DataFieldTypeTag } from "./DataFieldTypeTag";

interface Props {
  field: ContractFieldOption;
  onRemove: () => void;
}

export const SelectedDataField = ({ field, onRemove }: Props) => {
  const { t } = useTranslation();
  return (
    <Flex alignItems="center" borderRadius="md" backgroundColor="smBackgroundSecondary" pl="2.5" py="1" mt="1">
      <Text fontSize="sm" fontWeight="semibold" pr="5">
        {t(getDataFieldTranslationKey(field.name))}
      </Text>
      <DataFieldTypeTag type={field.type} size="sm" />
      <IconButton
        aria-label={t("Remove")}
        color="smMuted"
        variant="unstyled"
        icon={<Icon as={FaTimes} />}
        onClick={onRemove}
      />
    </Flex>
  );
};
